import Button1 from './components/Button1';
import detectEthereumProvider from '@metamask/detect-provider';
import Web3 from 'web3';
import './App.css'
import {BOUNCER_ABI , BOUNCER_ADDRESS , BOUNCE_ABI} from './config';

function App() {

    const connectWallet = async () => {

      const provider = await detectEthereumProvider()

      if (provider) {
        const accounts = await provider.request({ method: 'eth_requestAccounts' })
        const account = accounts[0]


      console.log('Ethereum successfully detected!', {account})
        }

        else {
        window.addEventListener('ethereum#initialized', detectEthereumProvider, {
        once: true,
        });

  // If the event is not dispatched by the end of the timeout,
  // the user probably doesn't have MetaMask installed.
  setTimeout(detectEthereumProvider, 3000); // 3 seconds
    }


  }
  const BuildBouncer = async () => {
    const provider = await detectEthereumProvider()
    const accounts = await provider.request({ method: 'eth_requestAccounts' })
    const account = accounts[0]
    const web3 = new Web3(provider)
    const contract = new web3.eth.Contract(
      BOUNCER_ABI,
      BOUNCER_ADDRESS
    );

    web3.eth.defaultAccount = account

    const input = document.getElementById("userInput").value;
    const input2 = document.getElementById("userInput2").value;

    const result = await contract.methods.buildBouncer(input2).send({
       from: web3.eth.defaultAccount,
       value: input * 10**18,
       gasPrice: '1000000000',
       gas: '150000',
       });
    console.log(result)
  }


  const bounceBackONE = async () => {
    const provider = await detectEthereumProvider()
    const accounts = await provider.request({ method: 'eth_requestAccounts' })
    const account = accounts[0]
    const web3 = new Web3(provider)
    const input3 = document.getElementById("userInput3").value;
    const contract = new web3.eth.Contract(
      BOUNCE_ABI,
      input3
    );

    web3.eth.defaultAccount = account

    const result2 = await contract.methods.bounceBackONE().send({
       from: web3.eth.defaultAccount,
       gasPrice: '1000000000',
       gas: '35000',
       });
    console.log(result2)


  }

  const grabONE = async () => {
    const provider = await detectEthereumProvider()
    const accounts = await provider.request({ method: 'eth_requestAccounts' })
    const account = accounts[0]
    const web3 = new Web3(provider)
    const input4 = document.getElementById("userInput4").value;
    const contract = new web3.eth.Contract(
      BOUNCE_ABI,
      input4
    );

    web3.eth.defaultAccount = account

    const result3 = await contract.methods.grabONE().send({
       from: web3.eth.defaultAccount,
       gasPrice: '1000000000',
       gas: '35000',
       });
    console.log(result3)


  }

  return (
    <div className="App">
      <Button1 onClick={connectWallet}>Connect Wallet</Button1>
      <Button1 onClick={BuildBouncer}>bounceONE</Button1>
      <input id="userInput" type="text" placeholder="Value: in ONE"></input>
      <input id="userInput2" type="text" placeholder="Bounce To: Address"></input>
      <p># Build bounce contract from factory to hold value</p>

      <Button1 onClick={bounceBackONE}>bounceBackONE</Button1>
      <input id="userInput3" type="text" placeholder="myBounce: Address"></input>
      <p># Bounce back ONE from created contract via sender</p>

      <Button1 onClick={grabONE}>grabONE</Button1>
      <input id="userInput4" type="text" placeholder="myBounce: Address"></input>
      <p># Grab ONE from created contract via receiver</p>
      <Button1>bouncePassONE</Button1>
      <p># TODO Adds password to bounceONE</p>
    </div>

  );


}

export default App;
